import { render, staticRenderFns } from "./Min.vue?vue&type=template&id=546f5f19"
import script from "./Min.vue?vue&type=script&lang=js"
export * from "./Min.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports